import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';

const DownloadReport = ({ onDownloadReport, loading }) => {
    const theme = useTheme();

    return (
        <Button
            variant="outlined"
            size="large"
            onClick={onDownloadReport}
            disabled={loading}
            style={{
                color: theme.palette.text.white,
                borderColor: '#bbbdbd',
                height: '52px',
                width: '52px',
                minWidth: '52px',
                borderRadius: '12px',
                padding: 0,
            }}
        >
            {loading ? (
                <CircularProgress size={24} color="inherit" />
            ) : (
                <DownloadIcon />
            )}
        </Button>
    );
};

export default DownloadReport;
